import { safeRedirectPath } from '~/utils/liff'

export default function({ route, store, redirect }) {
  if(!store.getters['auth/isLogin']){
    // http://localhost:3000/?campaign_uid=CC_4083995754 の campaign_uid 等はログイン画面へそのまま引き継ぐ（店舗テーマ）
    const queryString = route.fullPath.split("?")[1] || ''
    const params = new URLSearchParams(queryString)
    // ログイン後に元のページへ戻す（pages/login が safeRedirectPath を通して遷移する）。
    // 同一オリジンの相対パス（/ 始まり・// や /\ 始まりでない）だけを戻り先にする（オープンリダイレクト対策）
    const to = safeRedirectPath(route.fullPath)
    if (to !== '/') params.set('to', to)
    const qs = params.toString()
    return redirect(qs ? `/login/?${qs}` : '/login/')
  }

  // clientかどうかで処理
  // console.log("$route.fullPath",route.fullPath)
  // if(store.state.auth.client.status !== "active"){
  //   if(!route.fullPath.startsWith("/client/")) return redirect("/client/")
  // }

}
